import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=b558ce76&"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports